module.exports = __webpack_public_path__ + "img/cegep-beauce-appalache.1bbeb8e4.png";